const typographyModalCloneCheckSite = {
  text: 'Clonar Tipos de Servicio'
};

export default typographyModalCloneCheckSite;
